/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { DateTime } from 'luxon';

import DynamicFormatting from './DynamicFormatting';
import DynamicFormInput from './DynamicFormInput';
import { Question, Section } from './data';
import { generateIdName } from './utils';
import { useFlipOIDC } from '../../components/FlipOIDC';

function formatting(type: string) {
  return type.indexOf('heading') > -1;
}

interface DynamicQuestionProps {
  section?: Section;
  question: Question;
  control: Control;
}

export default function DynamicQuestion({
  section, question, control,
}: DynamicQuestionProps) {
  const { user } = useFlipOIDC();

  const getDefaultValue = () => {
    if (question.type === 'user') return `${user.givenName} ${user.familyName}`;
    if (question.type === 'checkbox') return undefined;
    if (question.type === 'now') return DateTime.now().toLocaleString(DateTime.DATETIME_FULL);
    if (question.type === 'weather') return 'Fine 15°C';
    return '';
  };

  // Generate unique name for this control
  const name = React.useMemo(() => generateIdName(section, question), [section, question]);

  if (formatting(question.type)) {
    return (
      <DynamicFormatting
        type={question.type}
        label={question.label}
        key={question.label}
      />
    );
  }

  return (
    <Controller
      key={question.label}
      name={name}
      control={control}
      rules={{ required: question.required }}
      defaultValue={getDefaultValue()}
      render={({ field, fieldState }) => (
        <DynamicFormInput
          question={question}
          error={fieldState.error}
          {...field}
        />
      )}
    />
  );
}
